import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserNotifications } from '@services/notifications/notifications.service';

export const fetchNotifications = createAsyncThunk(
  'notification/fetchNotifications',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserNotifications();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || error);
    }
  }
);

const initialState = {
  notifications: [],
  notificationsLoading: false,
  notificationsError: '',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchNotifications.pending, (state) => {
      state.notificationsLoading = true;
      state.notificationsError = '';
    });
    builder.addCase(fetchNotifications.fulfilled, (state, { payload }) => {
      state.notificationsLoading = false;
      state.notifications = payload;
    });
    builder.addCase(fetchNotifications.rejected, (state, { payload }) => {
      state.notificationsLoading = false;
      state.notificationsError = payload;
    });
  },
});

export default notificationSlice.reducer;

